import type { FaireProductEntity } from "../../entity_types/product";

export const p_ge8xckvffs: FaireProductEntity = {
  token: "p_ge8xckvffs",
  type: "product",
  name: "Room Linen Fragrance Spray",
  brandToken: "b_y6mta332qy",
  brandName: "Choice Blooms",
  imageUrl:
    "https://cdn.faire.com/fastly/48c4025cdad0873413f5dec61ceceeac55fa3ae29d6a2eaebb67974abd711426.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b77e9039774b000ad9f161f2af4aef2d56924babf0f98bc0ecb82a0f3b277ac4.jpeg",
    "https://cdn.faire.com/fastly/5eee494c3edc929c429b3b62d643d7190865726bc908bce8dcfce187fb48f27f.jpeg",
    "https://cdn.faire.com/fastly/daa0d7b0a33276d8bb8db8a8b7ea8ced486adef28492fec88d8c7aa4e375d0ad.jpeg",
    "https://cdn.faire.com/fastly/cfcbfa1f2c4c028c3623e81674c4b5ab67e8b9cece99373a745fd9f8fd2a13bd.jpeg",
    "https://cdn.faire.com/fastly/c2399e0e9cc5ed53bafcda526c8a040685fe3d181f1d35089c6da7970721ccef.jpeg",
    "https://cdn.faire.com/fastly/aa2ca7f352d77b70ba1d5d405c9587c667867cb9f33cb9d1992a3da50e029d95.jpeg",
    "https://cdn.faire.com/fastly/b30fca1b9815cfa6f7f3a232e41ed791e922d703430608c921f31deab09b4edf.jpeg",
    "https://cdn.faire.com/fastly/5ad4c55adcdbe8f12d84028d4ec8656faeda2f0edfdcca1108df87c08f0e4672.jpeg",
    "https://cdn.faire.com/fastly/bf86bcd1a4bb31dbe44b68ea94321c9282e42f68d7644d9d6280b603bc16ccff.jpeg",
    "https://cdn.faire.com/fastly/1df06a41433c088af397f722995a203e337ebd05f8ab09b19a07a28574a34e11.jpeg",
  ],
  priceDollars: 18,
  description:
    "Flameless. Uplifting. Refreshing.\n\nThe Choice Blooms Room + Linen Spray is designed for modern living—an effortless way to refresh a space, reset the mood, and elevate everyday moments. \n\nHoused in a 100ml (4 oz) amber glass vessel with a spray nozzle and signature colored marble look round top, it blends function with thoughtful design—made to sit out, not be hidden away.\n\n100ml amber glass vessel with spray nozzle and colored marble look round top. Formulated without added phthalates, parabens, DPG, or DPN.\n\nThe Smell: Comes in all of our signature scents \nNo. 1 OG + Agarwood (this scent is being discontinued till supplies last)- orange top\nNo. 2 Gingerwood + Palo Santo- dark green top\nNo. 3 Moss + Amber- pink top\nNo. 4 Rosemary + Sage- light green top\nNo. 5 Lavandin + Chamomile- purple top\nNo.6 Cactus + Aloe-orange top\nNo.7 Tobacco + Wood- brown top\nNo.8 Tomato + Herbs-dark green top\nNo.9 Grapefruit + Mint- light green top\nNo.10 Rose + Oud-pink top\nNo.11 Fig + Sage-brown top\nNo.12 Wild Flowers-purple top",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:28.588Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
